import React, {useEffect, useState} from 'react';
import "./CookieModal.sass"

function CookieModal(props) {
    const [modal, setModal] = useState(false)

    function buttonHandler() {
        localStorage.setItem('cookie', 'true')
        setModal(true)
    }

    useEffect(() => {
        setModal(localStorage.getItem('cookie'))
    }, [])

    return (!modal ?
            <div className={'fade-in-fwd cookie-modal'}>
                <div
                    style={{display: 'flex', alignItems: 'center'}}
                    className="cookie-text">
                    <i style={{marginRight: "40px", fontSize: '40px', color: 'white'}} className="far fa-eye"></i>
                    Мы используем cookie на нашем сайте. Если вы продолжите навигацию по сайту,
                    это значит, что вы с этим согласны.

                </div>
                <button onClick={buttonHandler}>Согласиться</button>
            </div> : ''
    )

}

export default CookieModal;